<template>
  <div class="irrigationRecordManagement-page">
    <div class="all-content-container">
      <div class="table-content-container" style="overflow: hidden">
        <div class="table-title-container flexC">
          <div class="flexC">
            <h4>配比</h4>
            <p @click="returnBack()" style="margin-left: 20px; cursor: pointer">
              <i class="el-icon-caret-left"></i>
              <span>返回</span>
            </p>
          </div>
          <el-button
            style="margin-right: 20px"
            @click="handleAdd()"
            size="small"
            type="primary"
            >+配比</el-button
          >
        </div>
        <div class="table-content">
          <div class="table-table">
            <el-table
              :data="tableData"
              style="width: 100%"
              :header-cell-style="{ background: '#f4f5f7' }"
              v-loading="loading"
            >
              <el-table-column label="成分名称" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.title }}</p>
                </template>
              </el-table-column>
              <el-table-column label="成分配比" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.propor }}</p>
                </template>
              </el-table-column>
              <el-table-column label="实际配比" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.realPropor }}</p>
                </template>
              </el-table-column>
              <el-table-column label="数值设备" align="center">
                <template slot-scope="scope">
                  <p>
                    {{ scope.row.deviceName }} _ {{ scope.row.attributeName }}
                  </p>
                </template>
              </el-table-column>
              <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                  <el-button
                    @click="handleUpdate(scope.row)"
                    type="text"
                    size="small"
                    >编辑</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    @click="handleDel(scope.row)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="pagination-content-container" style="float: right">
          <el-pagination
            background
            layout="prev, pager, next,jumper"
            class="pageTap"
            @current-change="handleCurrentChange"
            :current-page="searchForm.pageNum"
            :page-size="searchForm.pageSize"
            :total="total"
          ></el-pagination>
        </div>
        <el-dialog
          :title="title"
          :visible.sync="dialogVisible"
          width="640px"
          :before-close="handleClose"
        >
          <el-form
            ref="ruleForm"
            :rules="rules"
            :model="ruleForm"
            label-width="120px"
            class="demo-ruleForm"
          >
            <el-row>
              <el-col :span="24">
                <el-form-item label="成分名称：" prop="title">
                  <el-input
                    placeholder="请输入成分名称"
                    v-model="ruleForm.title"
                    maxlength="50"
                    show-word-limit
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="成分配比：" prop="propor">
                  <el-input-number
                    placeholder="请输入成分配比"
                    v-model="ruleForm.propor"
                    :precision="2"
                    :step="1"
                    :min="0"
                    :max="99999999"
                    size="small"
                  ></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="数值设备：" prop="numericalEquipmentId">
                  <el-select
                    v-model="ruleForm.numericalEquipmentId"
                    placeholder="请选择数值设备"
                    clearable
                  >
                    <el-option
                      v-for="(item, index) in deviceArray"
                      :label="item.deviceName + '_' + item.attributeName"
                      :value="item.id"
                      :key="index"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="handleClose()">取消</el-button>
            <el-button type="primary" @click="handleSave()">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        integratedGroupId: "",
      },
      ruleForm: {
        // 添加、编辑弹窗表单
        id: undefined,
        integratedGroupId: "",
        title: "",
        propor: "",
        numericalEquipmentId: "",
      },
      rules: {
        // 添加、编辑弹窗表单规则
        title: [
          {
            required: true,
            message: "请输入成分名称",
            trigger: "blur",
          },
        ],
        propor: [
          {
            required: true,
            message: "请输入成分配比",
            trigger: "blur",
          },
        ],
        numericalEquipmentId: [
          {
            required: true,
            message: "请选择数值设备",
            trigger: "change",
          },
        ],
      },
      total: 0, // 总数
      tableData: [],
      loading: false,
      dialogVisible: false,
      title: "添加配比", // 添加、编辑弹窗标题
      deviceArray: [], // 水肥机设备数组
    };
  },
  created() {
    // 查询
    this.handleSearch();

    // 获取水肥机设备列表
    this.getDeviceList();
  },
  methods: {
    // 查询
    handleSearch() {
      this.searchForm.pageNum = 1;
      this.getList();
    },
    // 分页查询
    handleCurrentChange: function (currentPage) {
      this.searchForm.pageNum = currentPage;
      this.getList();
    },
    // 重置
    reset() {
      this.searchForm = {
        pageNum: 1,
        pageSize: 10,
        integratedGroupId: "",
      };
      this.handleSearch();
    },
    // 获取列表
    getList() {
      this.searchForm.integratedGroupId = this.$route.query.id;
      this.loading = true;
      this.$api.device
        .getIrrigationProportionList(this.searchForm)
        .then((res) => {
          if (res.code == 200) {
            this.total = res.count;
            this.tableData = res.data;
          }
          this.loading = false;
        });
    },
    // 删除
    handleDel(row) {
      this.$confirm("是否确定删除？", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      }).then(() => {
        this.$api.device.delIrrigationProportion(row.id).then((res) => {
          if (res.code == 200) {
            this.$toaster.ok(res.msg);
            this.handleSearch();
          }
        });
      });
    },
    // 添加
    handleAdd() {
      this.title = "添加配比";
      this.ruleForm.id = "";
      this.dialogVisible = true;
    },
    // 编辑
    handleUpdate(row) {
      this.title = "编辑配比";
      this.dialogVisible = true;
      this.ruleForm.id = row.id;

      // 获取配比
      this.getIrrigationProportion(row.id);
    },
    // 获取配比
    getIrrigationProportion(id) {
      //根据ID详情
      this.$api.device.getIrrigationProportion({ id: id }).then((res) => {
        if (res.code == 200) {
          this.ruleForm = res.data;
        }
      });
    },
    // 保存
    handleSave() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.ruleForm.integratedGroupId = this.$route.query.id;
          this.$api.device
            .saveIrrigationProportion(this.ruleForm)
            .then((res) => {
              if (res.code == 200) {
                this.$toaster.ok(res.msg);
                this.handleClose();
                this.handleSearch();
              }
            });
        } else {
          this.$toaster.error("保存失败，请先完善配置信息");
        }
      });
    },
    // 关闭添加编辑弹窗
    handleClose() {
      this.$refs["ruleForm"].resetFields();
      this.dialogVisible = false;
    },
    // 获取水肥机设备列表
    getDeviceList() {
      this.$api.device
        .getDeviceByEquipmentId2(this.$route.query.linkageControlId, 0)
        .then((res) => {
          if (res.code == 200) {
            this.deviceArray = res.data;
          }
        });
    },
    // 返回
    returnBack() {
      this.$router.push({
        name: "fertilizerManagement",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/irrigationRecordManagement.scss";
.flexC {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 20px;
}

.demo-ruleForm {
  width: 95%;
  margin: -10px 0 0 0;
  padding-top: 10px;

  .el-row {
    margin-bottom: 20px;
  }

  .el-select {
    width: 100% !important;
  }

  .el-input-number {
    width: 100% !important;
  }

  .el-cascader {
    width: 100% !important;
    margin-bottom: 0px !important;
  }
}
</style>